<template>
  <div :style="{ width: width }">
    <el-popover :placement="placement" trigger="manual" :width="width" v-model:visible="realPopShow">
      <ul class="content" @scroll="onScroll">
        <li v-for="item in list" :key="item[realKeys.idKey]" @click="onItemClick(item)">
          <span v-if="displayFormat" v-html="item[realKeys.showNameKey]"></span>
          <span v-else>{{ item[realKeys.nameKey] }}</span>
          <!-- {{ displayFormat ? item[realKeys.showNameKey] : item[realKeys.nameKey] }} -->
        </li>
        <div v-if="list.length === 0" class="empty" v-loading="loading">
          <div v-if="!loading">未查询到结果</div>
        </div>
        <div class="loading" v-if="list.length > 0 && !noPage && pageNum !== totalPage">
          加载中...
        </div>
      </ul>
      <template #reference>
        <el-input
          v-model="state"
          :placeholder="placeholder"
          :prefix-icon="prefixIcon"
          :disabled="disabled"
          clearable
          @clear="onClear"
          @focus="onFocus"
          @blur="onBlur"
          @input="onInput"
        ><template #append v-if="appendFlag"><slot name="append"></slot></template></el-input>
      </template>
    </el-popover>
  </div>
</template>

<script>
import { computed, defineComponent, ref } from 'vue';
import { debounce } from 'lodash';

export default defineComponent({
  props: {
    width: {
      type: String,
      default: '300px',
    },
    placement: {
      type: String,
      default: 'bottom',
    },
    prefixIcon: String,
    placeholder: {
      type: String,
      default: '输入学员姓名 / 手机号后4位快速搜索',
    },
    api: {
      type: Function,
      required: true,
    },
    keys: {
      type: Object,
      default: () => ({
        searchKey: 'queryKey', // 接口查询字段
        idKey: 'id', // 接口id字段名称
        nameKey: 'name',
        showNameKey: 'showName',
      }),
    },
    queryParams: Object, // 额外的查询参数,有些接口需要
    displayFormat: Function,
    noPage: Boolean,
    disabled: Boolean,
    immediate: {
      type: Boolean,
      default: true,
    }, // 是否获取焦点立即查询
    // notAutoTrigger: Boolean, // 不自动获取值
    appendFlag: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const state = ref('');
    const popShow = ref(false);
    const list = ref([]);
    const realKeys = computed(() => ({
      searchKey: 'queryKey', // 接口查询字段
      idKey: 'id', // 接口id字段名称
      nameKey: 'name',
      showNameKey: 'showName',
      ...props.keys,
    }));
    const clickFlag = ref(false);
    const loading = ref(false);
    const isStartQuery = ref(false);
    const pageNum = ref(1);
    const totalPage = ref(1);
    const stateTemp = ref('');

    // const realPopShow = computed(() => popShow.value && list.value.length > 0);
    const realPopShow = computed(() => popShow.value && isStartQuery.value);

    const queryData = async () => {
      const params = {
        page: {
          pageNum: pageNum.value,
          pageSize: 10,
        },
      };
      if (realKeys.value.searchKey) {
        params[realKeys.value.searchKey] = state.value;
      }
      if (props.noPage) {
        delete params.page;
      }
      if (props.queryParams) {
        Object.assign(params, props.queryParams);
      }

      const { data, page } = await props.api(params).finally(() => {
        loading.value = false;
      });
      if (props.noPage) {
        list.value = data || [];
        if (props.displayFormat) {
          list.value = data?.map((it) => {
            const item = it;
            item[realKeys.value.showNameKey] = props.displayFormat(item);
            return item;
          }) || [];
        }
      } else {
        totalPage.value = page?.totalPage || 0;
        if (props.displayFormat) {
          const temp = data?.map((it) => {
            const item = it;
            item[realKeys.value.showNameKey] = props.displayFormat(item);
            return item;
          }) || [];
          list.value.push(...temp);
        } else {
          list.value.push(...(data || []));
        }
      }
    };
    const dd = debounce(() => {
      isStartQuery.value = true;
      loading.value = true;
      list.value = [];
      pageNum.value = 1;
      totalPage.value = 1;
      queryData();
    }, 300);
    return {
      realKeys,
      state,
      realPopShow,
      list,
      loading,
      pageNum,
      totalPage,
      onClear() {
        if (popShow.value) {
          dd();
        }
        emit('clear');
      },
      onFocus() {
        list.value = [];
        popShow.value = true;
        if (state.value.trim() || props.immediate) {
          stateTemp.value = state.value;
          state.value = '';
          dd();
        }
      },
      onBlur() {
        state.value = stateTemp.value;
        popShow.value = false;
        isStartQuery.value = false;
      },
      onInput() {
        if (realKeys.value.searchKey) {
          dd();
        }
      },
      onItemClick(item) {
        clickFlag.value = true;
        if (props.displayFormat) {
          // state.value = item[realKeys.value.showNameKey].trim();
          state.value = item[realKeys.value.nameKey].trim();
        } else {
          state.value = item[realKeys.value.nameKey].trim();
        }
        emit('select', item);
      },
      clearField() {
        state.value = '';
      },
      setField(str) {
        state.value = str || '';
      },
      onScroll(ev) {
        if (props.noPage || totalPage.value === pageNum.value) {
          return;
        }
        const { clientHeight, scrollHeight, scrollTop } = ev.target;
        if (scrollTop >= scrollHeight - clientHeight - 10) {
          pageNum.value += 1;
          queryData();
        }
      },
    };
  },
});
</script>

<style lang="scss">
.empty {
  .el-loading-spinner {
    top: 0;
    margin-top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
  }
}
</style>
<style lang="scss" scoped>
.content {
  margin: -12px;
  max-height: 300px;
  overflow: auto;
  li {
    padding: 8px 10px;
    cursor: pointer;
  }
  li:hover {
    background-color: var(--g7);
  }
  .empty {
    height: 100px;
    color: var(--g4);
    line-height: 100px;
    text-align: center;
  }
  .loading {
    color: var(--g4);
    text-align: center;
    padding: 8px 10px;
  }
}
</style>
